module.exports = __webpack_public_path__ + "img/customer.31ce7489.gif";